import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faExchangeAlt, 
    faMobileAlt,
    faCheckCircle,
    faReceipt,
    faSpinner,
} from '@fortawesome/free-solid-svg-icons'
import { useState } from 'react'
import BaseModal from './modals/BaseModal'
import { searchUser } from '../utils/searchUser'
import { sendMoney as transfer } from '../utils/sendMoney'
import topupImg from '../assets/images/topup.png'
import payBillsImg from '../assets/images/paybills.png'
import transferImg from '../assets/images/transfer.png'

const sendMoney = async (email, receiverId, amount) => {
    let receiver = receiverId ?  await searchUser(receiverId) : await searchUser("", email)
    if (receiver.code) {
        alert(receiver.message)
        return
    }
    receiver = receiver[0]
    let send = await transfer(sessionStorage.getItem('localId'), receiver.id, amount)
    if (send.code === 422) {
        alert(send.message)
    } else {
        alert(send.message)
    }
}

const Remittance = () => {
    const btnStyle = {
        width: '60px', 
        height: '60px', 
        borderRadius: '50%'
    }
    return (
        <div className="row py-3">
            <div className="col-4 text-center">
                <span className="bg-purple m-auto d-flex shadow-lg align-items-center justify-content-center" data-toggle="modal" data-target="#topup" style={btnStyle}>          
                    <button className="text-center text-white h4 px-0 border-0" style={{background: "transparent"}}>
                        <FontAwesomeIcon icon={faMobileAlt} />
                    </button>
                </span>
                <p>Topup</p>
                {<Topup />}
            </div>
            <div className="col-4 text-center">
                <span className="bg-purple m-auto d-flex shadow-lg align-items-center justify-content-center" data-toggle="modal" data-target="#transfer" style={btnStyle}>  
                    <button className="text-center text-white h4 px-0 border-0" style={{background: "transparent"}}>
                        <FontAwesomeIcon icon={faExchangeAlt} />
                    </button>
                </span>
                {<Transfer />}
                <p>Transfer</p>
            </div>
            <div className="col-4 text-center">
                <span className="bg-purple m-auto d-flex shadow-lg align-items-center justify-content-center" data-toggle="modal" data-target="#paybill" style={btnStyle}>  
                    <button className="text-center text-white h4 px-0 border-0" style={{background: "transparent"}}>
                        <FontAwesomeIcon icon={faReceipt} />
                    </button>
                </span>
                {<PayBill />}
                <p>Pay Bills</p>
            </div>
        </div>
    )
}

export default Remittance

const Transfer = () => {
    const [isPending, setIsPending] = useState(false)
    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsPending(true)
        let receiverId = e.target.pouch_id.value
        await sendMoney("", receiverId)
        setIsPending(false)
    }
    return (
        <BaseModal modalId="transfer" modalTitle="Transfer Money" modalTitleIcon={faExchangeAlt}>
            <div className="row p-3 d-flex justify-content-around">                
                <form onSubmit={handleSubmit} className="text-dark text-center">
                    <img src={transferImg} alt="Top Up " className="rounded-circle w-50" />
                    <div className="row text-left">
                        <div className="col-12 col-sm-6 col-md-12 col-lg-6 form-group">
                            <label className="small">From my:</label>
                            <select className="form-control">
                                <option>Pouch</option>
                                <option>Binance</option>
                            </select>
                        </div>
                        <div className="col-12 col-sm-6 col-md-12 col-lg-6 form-group">
                            <label className="small">To: </label>
                            <input name ="pouch_id" type="text" className="form-control" placeholder="Receiver Pouch ID or email" />
                        </div>
                    </div>
                    <div className="row text-left">
                        <div className="col form-group">
                            <input type="text" className="form-control" placeholder="0.00" />
                        </div>
                    </div>
                    <button type="submit" className="btn btn-purple shadow-sm w-100 mt-4">
                        {isPending ? 
                            <span>Sending <FontAwesomeIcon icon={faSpinner} spin /></span> : 
                            <span>Transfer <FontAwesomeIcon icon={faCheckCircle} /></span>}
                    </button>
                </form>
            </div>
        </BaseModal>
    )
}

const Topup = () => {
    const [isPending, setIsPending] = useState(false)
    const handleSubmit = async (e) => {
        setIsPending(true)
        e.preventDefault()
        // handle topup logic
        setIsPending(false)
    }
    return (
        <BaseModal modalId="topup" modalTitle="Topup" modalTitleIcon={faMobileAlt}>
            <div className="">                
                <form onSubmit={handleSubmit} className="text-dark text-center">
                    <img src={topupImg} alt="Top Up " className="rounded-circle w-50" />
                    <div className="row">
                        <div className="col-12 col-sm-6 col-md-12 col-lg-6 form-group">
                            <select className="form-control">
                                <option>Select subscription</option>
                                <option>AIRTIME</option>
                                <option>DATA</option>
                            </select>
                        </div>
                        <div className="col-12 col-sm-6 col-md-12 col-lg-6 form-group">
                            <select className="form-control">
                                <option>Select a network provider</option>
                                <option>MTN</option>
                                <option>AIRTEL</option>
                                <option>GLO</option>
                                <option>9Mobile</option>
                            </select>
                        </div>
                    </div>
                    <div className="row">                        
                        <div className="col form-group">
                            <input type="text" className="form-control" placeholder="Phone Number" />
                        </div>                      
                        <div className="col form-group">
                            <input type="text" className="form-control" placeholder="0.00" />
                        </div>
                    </div>
                    <button type="submit" className="btn btn-purple shadow-sm w-100 mt-4">
                        {isPending ? 
                            <span>Buying <FontAwesomeIcon icon={faSpinner} spin /></span> : 
                            <span>Topup <FontAwesomeIcon icon={faCheckCircle} /></span>}
                    </button>
                </form>
            </div>
        </BaseModal>
    )
}

const PayBill = () => {
    const [isPending, setIsPending] = useState(false)
    const handleSubmit = async (e) => {
        setIsPending(true)
        e.preventDefault()
        // handle paybill logic
        setIsPending(false)
    }
    return (
        <BaseModal modalId="paybill" modalTitle="Pay Bill" modalTitleIcon={faReceipt}>
            <div className="row p-3 d-flex justify-content-around">                
                <form onSubmit={handleSubmit} className="text-dark text-center">
                    <img src={payBillsImg} alt="Top Up " className="rounded-circle w-50" />
                    <div className="row">
                        <div className="col-12 col-sm-6 col-md-12 col-lg-6 form-group">
                            <select className="form-control">
                                <option>Select a service provider...</option>
                                <option>GoTV</option>
                                <option>DSTV</option>
                                <option>Spotify</option>
                                <option>Netflix</option>
                            </select>
                        </div>
                        <div className="col-12 col-sm-6 col-md-12 col-lg-6 form-group">
                            <select className="form-control">
                                <option>Select a plan...</option>
                                <option>Basic Plan</option>
                                <option>Student Plan</option>
                                <option>Family Plan</option>
                                <option>Premium</option>
                            </select>
                        </div>
                    </div>
                    <button type="submit" className="btn btn-purple shadow-sm w-100 mt-4">
                    {isPending ? 
                            <span>Paying <FontAwesomeIcon icon={faSpinner} spin /></span> : 
                            <span>Pay <FontAwesomeIcon icon={faCheckCircle} /></span>}
                    </button>
                </form>
            </div>
        </BaseModal>
    )
}
